import { computed, unref } from 'vue'
import type { ComputedRef, MaybeRef } from 'vue'
import type { Loadable } from '~/shared/types/loadable'

export type LoadableStatus = 'idle' | 'pending' | 'success' | 'error'

export function toLoadable<T>(
  data: MaybeRef<T>,
  status: MaybeRef<LoadableStatus>
): ComputedRef<Loadable<T>> {
  return computed(() => {
    const currentStatus = unref(status)

    return {
      data: unref(data),
      isLoading: currentStatus === 'idle' || currentStatus === 'pending',
      isError: currentStatus === 'error',
    }
  })
}

export function toLoadableFromFlags<T>(
  data: MaybeRef<T>,
  isLoading: MaybeRef<boolean>,
  isError: MaybeRef<boolean> = false
): ComputedRef<Loadable<T>> {
  return computed(() => ({
    data: unref(data),
    isLoading: unref(isLoading),
    isError: unref(isError),
  }))
}
